import {
  arrayRemove,
  arrayUnion,
  deleteField,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import React, { useContext, useState, useEffect } from "react";
import "../css/linkedAccounts.scss";
import { usersRef } from "../firebase";
import { AuthContext } from "../providers/AuthProvider";

// let incomingReqs = [
//   {
//     userRequestingLinkEmail: "some@Email.co.uk",
//     userRequestingLinkId: "jOWHB8Xnz6bckXZNoPi",
//   },
//   {
//     userRequestingLinkEmail: "some@ldkndldEmail.co.uk",
//     userRequestingLinkId: "jOWHB8Xnz6bckddNoPi",
//   },
//   {
//     userRequestingLinkEmail: "hello@gmailgmail.com",
//     userRequestingLinkId: "jOWHB8Xnz6bckXZNddddoPi",
//   },
//   {
//     userRequestingLinkEmail: "some@ldkndldEmail.co.uk",
//     userRequestingLinkId: "jOWHB8Xnz6bckddNoPi",
//   },
//   {
//     userRequestingLinkEmail: "hello@gmailgmail.com",
//     userRequestingLinkId: "jOWHB8Xnz6bckXZNddddoPi",
//   },
// ];

const LinkedAccounts = () => {
  const { userData } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");

  const [addLinkEmail, setAddLinkEmail] = useState("");

  const [requests, setRequests] = useState([]);

  useEffect(() => {
    let incomingReqs = userData?.incomingReqs ?? [];
    let requests = [];

    if (incomingReqs) {
      for (let req in incomingReqs) {
        requests.push(incomingReqs[req]);
      }
    }

    setRequests(requests);
  }, [userData]);

  // const [linkedIds] = useState(
  //   user?.associatedAccounts
  //     ? user.associatedAccounts.filter((u) => u !== user.uid)
  //     : []
  // );

  const [linkedAccounts, setLinkedAccounts] = useState([]);

  useEffect(() => {
    let linkedIds = userData?.associatedAccounts
      ? userData.associatedAccounts.filter((u) => u !== userData.uid)
      : [];

    async function getEmails() {
      let q = query(usersRef, where("uid", "in", linkedIds));
      getDocs(q).then((usersSnapshot) => {
        //Loop through users, for each user get their email and add it to an array

        let linkedEmails = [];

        usersSnapshot.forEach((user) => {
          //user.data()
          let userId = user.data().uid;
          let userEmail = user.data().email;
          linkedEmails.push({ userId, userEmail });
        });

        setLinkedAccounts(linkedEmails);
      });
    }

    try {
      if (linkedIds.length > 0) {
        getEmails();
      } else {
        setLinkedAccounts([]);
      }
    } catch (err) {
      console.error("error retreiving linked accounts", err);
      setErrorMessage("Error retreiving linked accounts");
    }
  }, [userData]);

  function addLinkRequest() {
    let q = query(usersRef, where("email", "==", addLinkEmail));
    getDocs(q)
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          setErrorMessage("No users with this email address", addLinkEmail);
        } else {
          querySnapshot.forEach((userDoc) => {
            // console.log("checking if user thing doc exists");
            if (userDoc.exists()) {
              let usersId = userDoc.data().uid;
              let usersEmail = userDoc.data().email;
              //              let usersRequests = userDoc.data().incomingReqs;
              // let timestamp = Date.now();

              //Add a request to the incoming in other users profile
              // usersRef.doc(usersId).update({
              //   incomingReqs: firestoreObj.FieldValue.arrayUnion({
              //     userRequestingLinkEmail: userData.email,
              //     userRequestingLinkId: userData.uid,
              //     // linkRequestedOn: timestamp,
              //   }),
              // });

              //Add a request to the incoming in other users profile
              updateDoc(doc(usersRef, usersId), {
                [`incomingReqs.${userData.uid}`]: {
                  userRequestingLinkEmail: userData.email,
                  userRequestingLinkId: userData.uid,
                  // linkRequestedOn: timestamp,
                },
              });

              //Add an outgoing request from your own profile
              updateDoc(doc(usersRef, userData.uid), {
                outgoingReqs: arrayUnion({
                  requestedLinkEmail: usersEmail,
                  requestedLinkId: usersId,
                  // linkRequestedOn: timestamp,
                }),
              });
            }
          });
        }
      })
      .catch((err) => {
        console.error("Error adding link request", err);
        setErrorMessage(err.message || "Error adding link request");
      });
  }

  async function acceptLinkRequest(reqUserId, reqUserEmail) {
    try {
      const updateRequestingUserOutgoing = await updateDoc(
        doc(usersRef, reqUserId),
        {
          outgoingReqs: arrayRemove({
            requestedLinkEmail: userData.email,
            requestedLinkId: userData.uid,
          }),
        }
      );

      const updateRequestingUserAccounts = await updateDoc(
        doc(usersRef, reqUserId),
        {
          associatedAccounts: arrayUnion(userData.uid),
        }
      );

      const updateOwnAssociated = await updateDoc(doc(usersRef, userData.uid), {
        associatedAccounts: arrayUnion(reqUserId),
      });

      const updateOwnIncoming = await updateDoc(doc(usersRef, userData.uid), {
        [`incomingReqs.${reqUserId}`]: deleteField(),
      });
    } catch (err) {
      console.error("Error accepting link request", err);
    }
  }

  async function rejectLinkRequest(reqUserId, reqUserEmail) {
    try {
      const updateRequestingUser = await updateDoc(doc(usersRef, reqUserId), {
        outgoingReqs: arrayRemove({
          requestedLinkEmail: userData.email,
          requestedLinkId: userData.uid,
        }),
      });

      const updateOwnProfile = await updateDoc(doc(usersRef, userData.uid), {
        [`incomingReqs.${reqUserId}`]: deleteField(),
      });
    } catch (err) {
      console.error("Error accepting link request", err);
    }
  }

  async function unlink(linkedUserId) {
    try {
      const updateRequestingUser = await updateDoc(
        doc(usersRef, linkedUserId),
        {
          associatedAccounts: arrayRemove(userData.uid),
        }
      );

      const updateOwnProfile = await updateDoc(doc(usersRef, userData.uid), {
        associatedAccounts: arrayRemove(linkedUserId),
      });
    } catch (err) {
      console.error("Error unlinking request", err);
    }
  }

  // console.log("USER DATA INCOMING REEEEQQQS", userData?.incomingReqs);
  return (
    <div className="linkedAccountsPage">
      <h3>{userData.email}</h3>
      <br />
      <p>{errorMessage}</p>
      <section className="linkedAccounts">
        <h2>Linked Accounts</h2>
        {linkedAccounts.length === 0 ? (
          <p>No linked accounts</p>
        ) : (
          <div>
            {linkedAccounts.map((acc) => {
              return (
                <div className="accountLine" key={acc.userId}>
                  <span>{acc.userEmail}</span>
                  <div className="accountActions">
                    <button onClick={() => unlink(acc.userId)}>unlink</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div className="formLine">
          <label htmlFor="addLink">Add Link</label>
          <input
            onChange={(e) => setAddLinkEmail(e.target.value)}
            value={addLinkEmail}
            placeholder="email"
            id="addLink"
            name="addLink"
            type="text"
          />
          <button onClick={addLinkRequest}>Add</button>
        </div>
      </section>
      <section className="linkRequests">
        <h2>Link Requests</h2>
        {userData?.outgoingReqs?.length > 0 && (
          <div>
            {userData?.outgoingReqs.map((outReq) => {
              //console.log("out req", outReq);
              return (
                <p key={outReq.requestedLinkId}>
                  {outReq.requestedLinkEmail} - Outgoing
                </p>
              );
            })}
          </div>
        )}

        {requests.length > 0 && (
          // {incomingReqs?.length > 0 && (
          <div>
            {requests.map((inReq) => {
              // {incomingReqs.map((inReq) => {
              // console.log("out req", inReq);
              return (
                <div
                  key={inReq.userRequestingLinkId}
                  className="linkRequestLine"
                >
                  <p>{inReq.userRequestingLinkEmail} - Incoming</p>
                  <div className="linkActions">
                    <button
                      onClick={() =>
                        acceptLinkRequest(
                          inReq.userRequestingLinkId,
                          inReq.userRequestingLinkEmail
                        )
                      }
                    >
                      Accept
                    </button>
                    <button
                      onClick={() =>
                        rejectLinkRequest(
                          inReq.userRequestingLinkId,
                          inReq.userRequestingLinkEmail
                        )
                      }
                    >
                      Reject
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
    </div>
  );
};

export default LinkedAccounts;
